import { Box, Button } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";

export function Menu({
  textoCategoria,
  textoHome,
  textoProduto,
  textoSegmento,
  textoUltraRapido
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  function handleSelectTextoSeo(option) {
    setSearchParams({ textoSeo: option })
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb="20px"
      w="100%"
      mx="auto"
    >
      <Button
        onClick={() => handleSelectTextoSeo('categoria')}
        variant={textoCategoria ? 'solid' : 'outline'}
        colorScheme="blue"
      >
        Alterar texto das categorias
      </Button>
      <Button
        onClick={() => handleSelectTextoSeo('home')}
        variant={textoHome ? 'solid' : 'outline'}
        colorScheme="blue"
      >
        Alterar texto da home
      </Button>
      <Button
        onClick={() => handleSelectTextoSeo('produto')}
        variant={textoProduto ? 'solid' : 'outline'}
        colorScheme="blue"
      >
        Alterar texto de produto
      </Button>
      <Button
        onClick={() => handleSelectTextoSeo('segmento')}
        variant={textoSegmento ? 'solid' : 'outline'}
        colorScheme="blue"
      >
        Alterar texto de segmento
      </Button>
      <Button
        onClick={() => handleSelectTextoSeo('ultra-rapido')}
        variant={textoUltraRapido ? 'solid' : 'outline'}
        colorScheme="blue"
      >
        Alterar texto ultra rápido
      </Button>
    </Box>
  )
}